var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tools"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.669 16.6671H16.669V11.6671L10.8357 5.83374C12.7017 4.94253 14.7982 4.65175 16.8364 5.00144C18.8745 5.35114 20.7541 6.3241 22.2164 7.78636C23.6787 9.24862 24.6516 11.1282 25.0013 13.1664C25.351 15.2046 25.0602 17.301 24.169 19.1671L34.169 29.1671C34.8321 29.8301 35.2046 30.7294 35.2046 31.6671C35.2046 32.6048 34.8321 33.504 34.169 34.1671C33.506 34.8301 32.6067 35.2026 31.669 35.2026C30.7313 35.2026 29.8321 34.8301 29.169 34.1671L19.169 24.1671C17.303 25.0583 15.2065 25.3491 13.1684 24.9994C11.1302 24.6497 9.25057 23.6767 7.78832 22.2145C6.32606 20.7522 5.35309 18.8726 5.0034 16.8344C4.6537 14.7962 4.94448 12.6998 5.83569 10.8337L11.669 16.6671Z",
    stroke: "#656667",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.b25e9454cfc37cde53de51cd0f88fec0.svg";
export { ForwardRef as ReactComponent };